<template>
  <div class="container-fluid ">
    <!--    <h1>This is an about page</h1>-->
    <div class="row justify-content-center">
      <div class="col gx-2">
        <div class="hstack  gap-3 justify-content-center">


          <!--      <label for="exampleFormControlInput1" class="form-label">Email address</label>-->
          <input ref="codeBox1" v-model="box1" v-on:keyup="box1keydown" type="text" class=" codeCell " autofocus autocomplete="off" id="code1" v-on:input="validateNumber">
          <input ref="codeBox2" v-model="box2" v-on:keyup="box2keydown" type="text" class=" codeCell " autocomplete="off" id="code2" v-on:input="validateNumber">
          <input ref="codeBox3" v-model="box3" v-on:keyup="box3keydown" type="text" class=" codeCell " autocomplete="off" id="code3" v-on:input="validateNumber">
          <input ref="codeBox4" v-model="box4" v-on:keyup="box4keydown" type="text" class=" codeCell" autocomplete="off" id="code4" v-on:input="validateNumber">

        </div>

        <span class="statusBar">{{deepStatus}}</span>
      </div>

    </div>

  </div>
</template>
<script>
import 'photoswipe/style.css';
import axios from "axios";
import {image_host} from "@/common/common";


export default {
  name: 'mainPage',
  data(){
    return {
      box1:"",
      box2:"",
      box3:"",
      box4:"",
      deepStatus:""
    }
  },
  props: {
    galleryID: String,
    images: Array,
  },
  setup(props) {
    return {
      imagesData: props.images,
    };
  },
  mounted() {
    var params = new URLSearchParams(window.location.search)
    console.log(window.location.search)
    var code = params.get("code");
    if (this.isUndefined(code)){
      return
    }
    if (code.length===4){
      this.loadViewInfo(code)
    }

  },
  unmounted() {

  },
  methods: {
    isUndefined(value) {
      if (value === undefined) {
        return true
      }
      if (value === null) {
        return true
      }

    },
    baseToa(str) {
      // 对字符串进行编码
      var encode = encodeURI(str)
      // 对编码的字符串转化base64
      var base64 = btoa(encode)
      return base64
    },
    toSerial(data){
    var str=JSON.stringify(data)
    return this.baseToa(str)
    },
    box1keydown(){
      this.printStatus()
      this.$refs.codeBox2.focus()
    },
    box2keydown(){
      this.printStatus()
      this.$refs.codeBox3.focus()
    },
    box3keydown(){
      this.printStatus()
      this.$refs.codeBox4.focus()
    },
    box4keydown(){
      this.printStatus()


      let viewcode=this.box1+this.box2+this.box3+this.box4
      this.loadViewInfo(viewcode)




    },
    getDate(){
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();  // 返回当前年份
      console.log(currentYear)
    },
    loadViewInfo(viewcode){
      let ow=this
      const defaultConfig = {
        timeout:120 * 1000,
        headers:{
          "content-type": "application/json",
        }
      }

      var reqData={
        viewcode:viewcode
      }
      var http=axios.create(defaultConfig)
      console.log(reqData)
      console.log(http)
      http.post(image_host,reqData)
          .then(respose=>{
            if (respose.status===200){
              // console.log(respose)
              var viewCodeData=respose.data
              // DeepZoomURL string
              // ArtistID    string
              // ProductID   string
              if (viewCodeData.code===0){
                //成功
                var data=viewCodeData.data
                console.log("data=",data)
                  this.$router.push({
                    // path: "/view",
                    name: "view",
                    params: {detail: this.toSerial(data)}//从哪个页面跳转
                  })
              }else{
                //失败
                ow.deepStatus=viewCodeData.message
                console.log(self.deepStatus)
              }

            }else{
              //failed
              ow.deepStatus=viewCodeData.message
              console.log(self.deepStatus)
            }
            console.log(respose.data)
          })
          .catch(error=>{
            // alert(error)
            ow.deepStatus=error.toString()
          })
    },
    printStatus(){
      console.log("code1=",this.box1)
      console.log("code2=",this.box2)
      console.log("code3=",this.box3)
    },
    validateNumber:function (event) {
      // 获取输入框的值
      var value = event.target.value;
      // 如果输入长度大于1，则删除最后一位
      if (value.length > 1) {
        event.target.value = value.substring(0, value.length - 1);
      }
    }
  },
};
</script>

<style>
DIV{
  cursor:pointer;
}
INPUT{
  cursor:pointer;
}
BODY{
  cursor:pointer;

}
.codeCell {
  width: 50px;
  height: 50px;
  border: 1px solid darkgray;
  background-color: gainsboro;
  font-size: 40px;
  text-align: center;
}
.codeCell:focus{
  border-color: aquamarine;
}
.statusBar{
  margin-top: 20px;
  color: #42b983;
}
</style>
